import React, {FC} from 'react';

import {RuleMultilineParameterCard} from '../ruleMultilineParameterCard';
import type {AtomCardProps} from './atomCard';
import {AtomIcon} from './atomIcon';
import {AtomTitle} from './atomTitle';

/*
 * Component.
 */

export const DefaultAtomCard: FC<AtomCardProps> = ({atom, onCancel}) => (
  <RuleMultilineParameterCard
    errorMessage={atom.errorMessage}
    title={<AtomTitle atom={atom} />}
    icon={<AtomIcon atom={atom} />}
    onCancel={onCancel}
  />
);
